import Cookies from 'js-cookie';

export function useThemeCookie() {
  return Cookies.get('theme') ?? 'light';
}

export default useThemeCookie;
